import React from 'react'
import Badge from '../CardVehicle/Badge'
import IconShielded from '../CardVehicle/IconShielded'
import IconPremium from '../CardVehicle/IconPremium'
import IconCertifiedDekra from '../CardVehicle/IconCertifiedDekra'
import EmbedVideoIframe from '../Utils/EmbedVideoIframe'

const Item = ({
  className, image, url, special, shielded, premium, certifiedDekra,
  onClick,
}) => {
  return (
    <div className={`carousel-gallery__item-resource ${className}`} onClick={() => onClick({ image })}>
      <header className="carousel-gallery__item-header">
        {special &&
          <Badge>Oferta Especial</Badge>
        }
        {shielded &&
          <IconShielded title="Veículo Blindado" />
        }
        {premium &&
          <IconPremium title="Veículo Premium" />
        }
        {certifiedDekra &&
          <IconCertifiedDekra title="Certificado Dekra" />
        }

      </header>
      { url ? <EmbedVideoIframe url={url} /> : <img src={image} />}

    </div>
  )
}

export default Item
